var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9 0a9 9 0 1 0 9 9 9 9 0 0 0-9-9Zm2.986 12.977-.41.409a.867.867 0 0 0-.224.389c-.055.205-.1.413-.173.612l-.631 1.7A7.253 7.253 0 0 1 9 16.258v-.994a2.717 2.717 0 0 0-.821-1.86 1.161 1.161 0 0 1-.34-.821v-1.162a1.157 1.157 0 0 0-.6-1.015 58.583 58.583 0 0 0-1.771-.948 5.231 5.231 0 0 1-1.149-.789l-.029-.026a4.166 4.166 0 0 1-.655-.753c-.34-.5-.895-1.322-1.255-1.856a7.3 7.3 0 0 1 3.747-3.697L7 2.773a.581.581 0 0 0 .84-.519v-.41a7.253 7.253 0 0 1 .885-.088l1.026 1.027a.581.581 0 0 1 0 .821l-.17.17-.375.375a.29.29 0 0 0 0 .41l.17.17a.29.29 0 0 1 0 .41l-.29.29a.291.291 0 0 1-.205.085h-.327a.29.29 0 0 0-.2.082l-.36.35a.291.291 0 0 0-.057.338L8.5 7.418a.29.29 0 0 1-.259.42h-.2a.29.29 0 0 1-.19-.071l-.337-.292a.581.581 0 0 0-.564-.112l-1.137.374a.434.434 0 0 0-.057.8l.4.2a2.458 2.458 0 0 0 1.1.26c.382 0 .82.99 1.161 1.161h2.422a1.162 1.162 0 0 1 .821.34l.5.5a1.107 1.107 0 0 1 .324.783 1.689 1.689 0 0 1-.5 1.2Zm3.147-3.315a.871.871 0 0 1-.514-.362l-.653-.979a.87.87 0 0 1 0-.966l.711-1.066a.87.87 0 0 1 .335-.3l.471-.236a7.031 7.031 0 0 1 .708 4.169Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.a141ca6dc4b9603a397a279defbc84d3.svg";
export { ForwardRef as ReactComponent };